import { render } from "./OneLine.vue?vue&type=template&id=8252ed34"
import script from "./OneLine.vue?vue&type=script&lang=js"
export * from "./OneLine.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/sparta-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__